import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsEarlyAccessEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.EARLY_ACCESS_FACILITIES, { defaultValue: false });
}
